import React, { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import CompanySidebar from '../../components/shared/sidebar/CompanySidebar';
import './CompanyLayout.scss';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../store/store';
import {
  getCompany,
  setCompanyExistsError,
  setCompanyTokenExhausted,
  setTrialPeriodEnded
} from '../../store/slices/companySlice';
import { setTokenExhausted } from '../../store/slices/authSlice';
import { setCandidateTokenExhausted } from '../../store/slices/candidateSlice';
import { getNotifications } from '../../store/slices/notificationSlice';
import MatchModal from '../../components/match-modal/MatchModal';
import { setIsMatchModal } from '../../store/slices/modalSlice';
import { checkIfCompanyToken } from '../../utils/check-if-company-token';
import { toast } from 'react-toastify';
import i18n from '../../i18n/i18n';
import Header from '../../components/shared/header/Header';
import AiLimitReachedModal from '../../components/AI-limit-reached-modal/AiLimitReachedModal';
import VerificationWarning from '../../components/ui/verification-warning/VerificationWarning';

const CompanyLayout = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const company = useSelector((state: RootState) => state.companyReducer);
  const companyTokenExhausted = useSelector(
    (state: RootState) => state.companyReducer.tokenExhausted
  );
  const tokenExhausted = useSelector(
    (state: RootState) => state.authReducer.tokenExhausted
  );
  const companyDoNotExists = useSelector(
    (state: RootState) => state.companyReducer.companyDoNotExists
  );
  const isMatchModal = useSelector(
    (state: RootState) => state.modalReducer.isMatchModal
  );
  const trialPeriodEnded = useSelector(
    (state: RootState) => state.companyReducer.trialPeriodEnded
  );

  useEffect(() => {
    if (!checkIfCompanyToken()) {
      dispatch(setCompanyExistsError(true));
      toast.error(i18n.t('messages.companyNotExists'));
      return;
    }

    dispatch(getCompany());
    dispatch(getNotifications());
  }, [dispatch]);

  // useEffect(() => {
  //   if (!companyTokenExhausted) return;
  //   dispatch(refreshToken());
  // }, [companyTokenExhausted]);

  useEffect(() => {
    return () => {
      dispatch(setTokenExhausted(false));
      dispatch(setCompanyExistsError(false));
      dispatch(setCompanyTokenExhausted(false));
      dispatch(setCandidateTokenExhausted(false));
      dispatch(setTrialPeriodEnded(false));
    };
  }, []);

  useEffect(() => {
    console.log('tokenExhausted', tokenExhausted);
    if (tokenExhausted) {
      navigate('/');
    }
  }, [tokenExhausted]);

  useEffect(() => {
    console.log('companyDoNotExists', companyDoNotExists);
    if (companyDoNotExists) {
      navigate('/');
    }
  }, [companyDoNotExists]);

  useEffect(() => {
    console.log('companyTokenExhausted', companyTokenExhausted);
    if (companyTokenExhausted) {
      navigate('/');
    }
  }, [companyTokenExhausted]);

  useEffect(() => {
    console.log('trialPeriodEnded', trialPeriodEnded);
    if (trialPeriodEnded) {
      navigate('/company/profile/plans');
    }
  }, [trialPeriodEnded]);

  function handleClose(): void {
    dispatch(setIsMatchModal(false));
  }

  return (
    <>
      {company.companyId && !company.is_verified && (
        <VerificationWarning userEmail={company.email} />
      )}
      <div className='app-wrapper'>
        <Header isCompany={true} />
        <CompanySidebar trialPeriodEnded={trialPeriodEnded} />
        <div className='zestur-company-wrapper' style={{background: 'linear-gradient(135deg, #ffffff 20%, #72c6e9 80%)'}}>
          <Outlet />
        </div>

        <MatchModal show={isMatchModal} handleClose={handleClose} />
        <AiLimitReachedModal />
      </div>
    </>
  );
};

export default CompanyLayout;
